/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RouteTrip } from "./RouteTrip";
import {
  RouteTripFromJSON,
  RouteTripFromJSONTyped,
  RouteTripToJSON,
  RouteTripToJSONTyped,
} from "./RouteTrip";

/**
 *
 * @export
 * @interface RouteResponseAlternatesInner
 */
export interface RouteResponseAlternatesInner {
  /**
   *
   * @type {RouteTrip}
   * @memberof RouteResponseAlternatesInner
   */
  trip?: RouteTrip;
}

/**
 * Check if a given object implements the RouteResponseAlternatesInner interface.
 */
export function instanceOfRouteResponseAlternatesInner(
  value: object,
): value is RouteResponseAlternatesInner {
  return true;
}

export function RouteResponseAlternatesInnerFromJSON(
  json: any,
): RouteResponseAlternatesInner {
  return RouteResponseAlternatesInnerFromJSONTyped(json, false);
}

export function RouteResponseAlternatesInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RouteResponseAlternatesInner {
  if (json == null) {
    return json;
  }
  return {
    trip: json["trip"] == null ? undefined : RouteTripFromJSON(json["trip"]),
  };
}

export function RouteResponseAlternatesInnerToJSON(
  json: any,
): RouteResponseAlternatesInner {
  return RouteResponseAlternatesInnerToJSONTyped(json, false);
}

export function RouteResponseAlternatesInnerToJSONTyped(
  value?: RouteResponseAlternatesInner | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    trip: RouteTripToJSON(value["trip"]),
  };
}
